// import { createAsyncThunk } from "@reduxjs/toolkit";
// import { checkSessionAPI, postLogIn } from "./apis";
// import toast from "react-hot-toast";


// export const checkUserSessionAction = createAsyncThunk(
//     "Auth/checkUserSession",
//     async () => {
//       const res = await checkSessionAPI();
//       if (res.status === 204) throw new Error("Session is not valid");
//       return res;
//     }
//   );
  
//   export const addLogIn = createAsyncThunk("login/loginDOc", async (payload) => {
//     const resultPromise = new Promise((resolve, reject) => {
//       postLogIn(payload)
//         .then((res) => {
//           localStorage.setItem("AdminHeaven", res.data?.token);
//           resolve(res.data);
//         })
//         .catch(({ response }) => {
//           reject(response.data?.message || "Something went wrong");
//         });
//     });
  
//     toast.promise(resultPromise, {
//       loading: "Signing...",
//       success: "Signed In successfully",
//       error: (err) => err,
//     });
  
//     return await resultPromise;
//   });
  

import { createAsyncThunk } from "@reduxjs/toolkit";
import { checkSessionAPI, postLogIn } from "./apis";

export const checkUserSessionAction = createAsyncThunk(
  "Auth/checkUserSession",
  async (_, { rejectWithValue }) => {
    try {
      const res = await checkSessionAPI();
      if (res.status === 204) {
        return rejectWithValue("Session is not valid");
      }
      return res.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Session check failed"
      );
    }
  }
);

export const addLogIn = createAsyncThunk(
  "login/loginDoc",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await postLogIn(payload);

      if (res.data?.token) {
        localStorage.setItem("AdminHeaven", res.data.token);
        return res.data;
      }

      throw new Error("No token received");
    } catch (error) {
      console.error("Login Action Error:", error);

      const errorMessage =
        error.response?.data?.message || error.message || "Login failed";

      return rejectWithValue(errorMessage);
    }
  }
);



// import { createAsyncThunk } from "@reduxjs/toolkit";
// import { checkSessionAPI, postLogIn } from "./apis";
// import toast from "react-hot-toast";

// export const checkUserSessionAction = createAsyncThunk(
//   "Auth/checkUserSession",
//   async (_, { rejectWithValue }) => {
//     try {
//       const res = await checkSessionAPI();
//       if (res.status === 204) {
//         return rejectWithValue("Session is not valid");
//       }
//       return res.data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data?.message || "Session check failed");
//     }
//   }
// );

// export const addLogIn = createAsyncThunk(
//     "login/loginDoc",
//     async (payload, { rejectWithValue }) => {
//       try {
//         const res = await postLogIn(payload);
        
//         if (res.data?.token) {
//           localStorage.setItem("AdminHeaven", res.data.token);
//           return res.data;
//         }
        
//         throw new Error("No token received");
//       } catch (error) {
//         console.error('Login Action Error:', error);
        
//         const errorMessage = 
//           error.response?.data?.message || 
//           error.message || 
//           "Login failed";
        
//         return rejectWithValue(errorMessage);
//       }
//     }
//   );